import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationUpdateVariationImageMetaArgs,
  BackendVariation,
} from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateVariationImageMeta($id: ID!, $imageMeta: JSON!) {
    updateVariationImageMeta(id: $id, imageMeta: $imageMeta) {
      id
    }
  }
`;

type Variables = BackendMutationUpdateVariationImageMetaArgs;
type Result = Pick<BackendVariation, 'id'>;

export const updateVariationImageMeta = async ({ id, imageMeta }: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      id,
      imageMeta: JSON.stringify(imageMeta || {}),
    },
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
